import type { IconProps } from './schemas';

export function WarningIcon({
  className = 'h-4 w-4 self-center inline-block',
}: IconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.1852 4.65933L2.95191 17.1873C2.14524 18.5847 3.15324 20.3327 4.76791 20.3327H19.2346C20.8492 20.3327 21.8572 18.586 21.0506 17.1873L13.8172 4.65933C13.0106 3.26199 10.9919 3.26199 10.1852 4.65933Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0039 8.66602V13.3327"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0013 18.0905C11.2653 18.0905 10.668 17.4918 10.668 16.7572C10.668 16.0225 11.2653 15.4238 12.0013 15.4238C12.7373 15.4238 13.3346 16.0225 13.3346 16.7572C13.3346 17.4918 12.7373 18.0905 12.0013 18.0905Z"
        fill="currentColor"
      />
    </svg>
  );
}
